import { render, staticRenderFns } from "./BackhaulView.vue?vue&type=template&id=40fd463c"
import script from "./BackhaulView.vue?vue&type=script&lang=js"
export * from "./BackhaulView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports